// ==============================================================
// ⚠️ RiskPatterns.jsx — Detecção de padrões de risco
// ==============================================================

import React, { useEffect, useState } from "react";
import { listenAllMessages } from "../../../services/iaDashboard/messagesService";
import { detectRiskPatterns } from "../../../services/iaDashboard/insightsService";

export default function RiskPatterns() {
  const [risks, setRisks] = useState([]);

  useEffect(() => {
    const unsub = listenAllMessages((messages) => {
      setRisks(detectRiskPatterns(messages || []));
    });

    return () => unsub && unsub();
  }, []);

  return (
    <div className="ia-insight-card">
      <div className="ia-insight-title">Padrões de Risco</div>

      {risks.length === 0 && (
        <p className="ia-chart-empty">Nenhum padrão de risco detectado.</p>
      )}

      {risks.map((r, i) => (
        <div key={i} className="ia-realtime-feed-item">
          <strong style={{ color: "#b22857" }}>{r.type}:</strong>{" "}
          {r.sample}
        </div>
      ))}
    </div>
  );
}
